import { config } from 'data';
import { statisticsService } from 'services';
import { useQuery } from 'hooks';
import { StatisticsPayoutsParams } from 'types/services';

const useStatisticsPayoutsQuery = (params: StatisticsPayoutsParams) => useQuery({
  queryKey: [config.STATISTICS_PAYOUTS_QUERY_KEY, params],
  queryFn: () => statisticsService.getPayouts(params),
});

export default useStatisticsPayoutsQuery;
